import dayjs from 'dayjs';
import getItemStyles from '../../../utils/item-styles.js';

let blankItemStyle = getItemStyles('no-info');

const blockFutureUnpostedDays = (groups, items, scheduleFormat) => {
  const currentDate = dayjs();
  for (let group of groups){
    for (let i = 1; i < scheduleFormat; i++) {
      const date =currentDate.add(i, 'day');
      // console.log(`${group.id}: ${date.format('M/D')}`); // debug
      // check if group (resource) has any items on this day
      const haveItem = items.some(item => {
        return (
          item.group === group.id
          &&
          item.start_time.format('M/D') === date.format('M/D')
        );
      });
      if (!haveItem) {
        const blankItem = {
          id: `${group.id}-no-info-${date.format('M/D')}`,
          itemType: 'no-info',
          group: group.id,
          title: "No info",
          start_time: date.startOf('day'),
          end_time: date.endOf('day'),
          backgroundColor: blankItemStyle.backgroundColor,
          color: blankItemStyle.color,
          borderStyle: blankItemStyle.borderStyle,
          borderColor: blankItemStyle.borderColor
          };
          items.push(blankItem);
      }
    }
  }
  return items;
}

export default blockFutureUnpostedDays;
